import type { TIdRef } from './common';
import type { TUserFacility } from './facility';

export enum EUserFacilityRelationType {
  ADMINISTRATE = 'default',
  READ = 'readonly',
}

export type TUserFacilityRelation = {
  id: number
  facility_id: TUserFacility
};

/* A user's link to a facility, as an id or an expanded object, so CMS and frontend reads fit. */
export type TFacilityRelationRef = Readonly<{
  facility_id: TIdRef
  type: EUserFacilityRelationType | null
}>;

/* The user fields vacation settings resolve from. */
export type TVacationFacilityUser = Readonly<{
  facilities?: ReadonlyArray<TFacilityRelationRef> | null,
  main_facility?: TIdRef,
}>;
